"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isRequesting: false,
  isProcessing: false,
  selectedOption: null
};
var _ref = /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "Reset"), " This reset the startlist and race order to the defaults.");
var _ref2 = /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "Fix"), " This will leave the startlist as is, but add in any missing races or phases. The placing of the new races may appear a bit random!");
class ResetOrFix extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleRequest", () => {
      this.setState({
        isRequesting: !this.state.isRequesting
      });
    });
    _defineProperty(this, "_onSetOption", value => {
      this.setState({
        selectedOption: value
      });
    });
    _defineProperty(this, "_onResetOrFix", () => {
      if (!this.state.selectedOption || this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      if (this.state.selectedOption === 'RESET') {
        this.props.initialiseStartList(this.props.competitionID);
      }
      if (this.state.selectedOption === 'FIX') {
        this.props.addBackMissingRuns(this.props.competitionID);
      }
      this.setState(initialState);
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onResetOrFix,
      type: "primary",
      disabled: this.state.isProcessing || !this.state.selectedOption
    }, "Confirm"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest,
      loading: this.state.loading,
      style: {
        marginBottom: '8px'
      }
    }, "Reset/Fix Parameters"), !this.state.isRequesting ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: modalButtons,
      onClose: this._onToggleRequest,
      title: "Fix or Reset Start List"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "selectedOption",
      checked: this.state.selectedOption === 'RESET',
      onChange: () => this._onSetOption('RESET'),
      label: _ref
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "selectedOption",
      checked: this.state.selectedOption === 'FIX',
      onChange: () => this._onSetOption('FIX'),
      label: _ref2
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(ResetOrFix, undefined, (client, props) => ({
  initialiseStartList(competitionID) {
    return client.update('StartListRun.initialiseStartList', {
      competitionID
    });
  },
  addBackMissingRuns(competitionID) {
    return client.update('StartListRun.addBackMissingRuns', {
      competitionID
    });
  }
}));